import React from 'react';
import { Text, StyleProp, TextStyle } from 'react-native';

/*   ====================================================================   */

interface IOBNakedText
{
getStyle : () => StyleProp<TextStyle>;

getText: () => string;

bindEvent : (onEvent    : (() => void), 
             bSubscribe : boolean) => void;
}

/*   ====================================================================   */

export default class OBNakedText extends React.Component<IOBNakedText>
   {
   UpdateData()
   {
   var sText = this.props.getText();

   if (this.state.sText != sText)
      this.setState({sText: sText});
   }

   /*   ------------------------------------------------------------------   */

   constructor(props)
   {
   super(props);
   this.UpdateData = this.UpdateData.bind(this);
   }

   /*   ------------------------------------------------------------------   */

   componentDidMount() 
   {
   this.props.bindEvent(this.UpdateData, true);
   }

   /*   ------------------------------------------------------------------   */

   componentWillUnmount() 
   {
   this.props.bindEvent(this.UpdateData, false);
   }

   /*   ------------------------------------------------------------------   */

   state = {sText: ""}

   /*   ------------------------------------------------------------------   */

   render() 
   {
   return (
         <Text style={this.props.getStyle()}> {this.state.sText} </Text>
          );
   }
}